const getters = {
  question: (state) => {
    return state.question
  },
  answer: (state) => {
    return state.answer
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/raceQuestion/getters.js